// React / Next
import { motion, Variants } from 'framer-motion';

// Dense SVG container variants for high path count (~50 paths)
const denseSvgContainerVariants: Variants = {
  initial: { opacity: 1 },
  rest: {
    transition: {
      delayChildren: 0.15,
      staggerChildren: 0.005,
      staggerDirection: -1,
    },
  },
  hover: {
    transition: {
      staggerChildren: 0.005,
      staggerDirection: 1,
    },
  },
};

// Path animation variants (vertical slide)
const svgPathVariants: Variants = {
  initial: { y: 280, opacity: 0 },
  rest: {
    y: 0,
    opacity: 1,
    transition: {
      duration: 0.5,
      ease: [0.34, 1.56, 0.64, 1],
    },
  },
  hover: {
    y: 280,
    opacity: 0,
    transition: { duration: 0.3, ease: 'easeIn' },
  },
};

/**
 * CFOsGraphic - Abstract horizontal lines pattern
 * Optimized for high path density with faster stagger timing
 */
export const CFOsGraphic = () => (
  <motion.svg
    viewBox="0 0 146 262"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="w-auto h-full block"
    variants={denseSvgContainerVariants}
    aria-hidden="true"
  >
    <motion.g clipPath="url(#clip0_cfos)">
      <motion.path
        variants={svgPathVariants}
        d="M53.1113 0H0V8.73646H53.1113V0Z"
        fill="#022E40"
      />
      <motion.path
        variants={svgPathVariants}
        d="M106.817 1.61353H0V8.73643H106.817V1.61353Z"
        fill="#022E40"
      />
      <motion.path
        variants={svgPathVariants}
        d="M158.217 4.8407H0V8.73649H158.217V4.8407Z"
        fill="#022E40"
      />
      <motion.path
        variants={svgPathVariants}
        d="M53.1113 9.47778H0V18.2142H53.1113V9.47778Z"
        fill="#022E40"
      />
      <motion.path
        variants={svgPathVariants}
        d="M106.817 11.0841H0V18.207H106.817V11.0841Z"
        fill="#022E40"
      />
      <motion.path
        variants={svgPathVariants}
        d="M210.621 14.3113H0V18.2071H210.621V14.3113Z"
        fill="#022E40"
      />
      <motion.path
        variants={svgPathVariants}
        d="M53.1113 19.1011H0V27.8375H53.1113V19.1011Z"
        fill="#022E40"
      />
      <motion.path
        variants={svgPathVariants}
        d="M106.817 20.7146H0V27.8375H106.817V20.7146Z"
        fill="#022E40"
      />
      <motion.path
        variants={svgPathVariants}
        d="M158.217 23.9417H0V27.8374H158.217V23.9417Z"
        fill="#022E40"
      />
      <motion.path
        variants={svgPathVariants}
        d="M53.1113 29.0441H0V37.7805H53.1113V29.0441Z"
        fill="#022E40"
      />
      <motion.path
        variants={svgPathVariants}
        d="M106.817 30.6576H0V37.7805H106.817V30.6576Z"
        fill="#022E40"
      />
      <motion.path
        variants={svgPathVariants}
        d="M158.217 33.8846H0V37.7804H158.217V33.8846Z"
        fill="#022E40"
      />
      <motion.path
        variants={svgPathVariants}
        d="M53.1113 38.5219H0V47.2583H53.1113V38.5219Z"
        fill="#022E40"
      />
      <motion.path
        variants={svgPathVariants}
        d="M106.817 41.5018H0V47.251H106.817V41.5018Z"
        fill="#022E40"
      />
      <motion.path
        variants={svgPathVariants}
        d="M158.217 43.3552H0V47.251H158.217V43.3552Z"
        fill="#022E40"
      />
      <motion.path
        variants={svgPathVariants}
        d="M53.1113 47.9924H0V56.7289H53.1113V47.9924Z"
        fill="#022E40"
      />
      <motion.path
        variants={svgPathVariants}
        d="M106.817 51.1978H0V56.7216H106.817V51.1978Z"
        fill="#022E40"
      />
      <motion.path
        variants={svgPathVariants}
        d="M158.217 52.8258H0V56.7216H158.217V52.8258Z"
        fill="#022E40"
      />
      <motion.path
        variants={svgPathVariants}
        d="M53.1113 57.7755H0V66.512H53.1113V57.7755Z"
        fill="#022E40"
      />
      <motion.path
        variants={svgPathVariants}
        d="M106.817 60.988H0V66.5119H106.817V60.988Z"
        fill="#022E40"
      />
      <motion.path
        variants={svgPathVariants}
        d="M158.217 62.6162H0V66.512H158.217V62.6162Z"
        fill="#022E40"
      />
      <motion.path
        variants={svgPathVariants}
        d="M53.1113 67.406H0V76.1425H53.1113V67.406Z"
        fill="#022E40"
      />
      <motion.path
        variants={svgPathVariants}
        d="M106.817 70.6113H0V76.1352H106.817V70.6113Z"
        fill="#022E40"
      />
      <motion.path
        variants={svgPathVariants}
        d="M158.217 72.2466H0V76.1424H158.217V72.2466Z"
        fill="#022E40"
      />
      <motion.path
        variants={svgPathVariants}
        d="M53.1113 77.8286H0V85.4603H53.1113V77.8286Z"
        fill="#022E40"
      />
      <motion.path
        variants={svgPathVariants}
        d="M158.217 81.5573H0V85.453H158.217V81.5573Z"
        fill="#022E40"
      />
      <motion.path
        variants={svgPathVariants}
        d="M53.1113 87.4591H0V95.0908H53.1113V87.4591Z"
        fill="#022E40"
      />
      <motion.path
        variants={svgPathVariants}
        d="M211 91.1078H104.183V95.0835H211V91.1078Z"
        fill="#022E40"
      />
      <motion.path
        variants={svgPathVariants}
        d="M158.217 92.1763H0V95.0836H158.217V92.1763Z"
        fill="#022E40"
      />
      <motion.path
        variants={svgPathVariants}
        d="M53.1113 97.8745H0V104.082H53.1113V97.8745Z"
        fill="#022E40"
      />
      <motion.path
        variants={svgPathVariants}
        d="M211 100.106H104.183V104.082H211V100.106Z"
        fill="#022E40"
      />
      <motion.path
        variants={svgPathVariants}
        d="M158.217 101.174H0V104.082H158.217V101.174Z"
        fill="#022E40"
      />
      <motion.path
        variants={svgPathVariants}
        d="M53.1113 107.665H0V113.872H53.1113V107.665Z"
        fill="#022E40"
      />
      <motion.path
        variants={svgPathVariants}
        d="M211 109.896H104.183V113.872H211V109.896Z"
        fill="#022E40"
      />
      <motion.path
        variants={svgPathVariants}
        d="M158.217 110.958H0V113.865H158.217V110.958Z"
        fill="#022E40"
      />
      <motion.path
        variants={svgPathVariants}
        d="M53.1113 117.135H0V123.343H53.1113V117.135Z"
        fill="#022E40"
      />
      <motion.path
        variants={svgPathVariants}
        d="M211 119.367H104.183V123.343H211V119.367Z"
        fill="#022E40"
      />
      <motion.path
        variants={svgPathVariants}
        d="M158.217 120.435H0V123.343H158.217V120.435Z"
        fill="#022E40"
      />
      <motion.path
        variants={svgPathVariants}
        d="M53.1113 127.078H0V133.286H53.1113V127.078Z"
        fill="#022E40"
      />
      <motion.path
        variants={svgPathVariants}
        d="M211 128.365H104.183V133.286H211V128.365Z"
        fill="#022E40"
      />
      <motion.path
        variants={svgPathVariants}
        d="M158.217 129.906H0V133.293H158.217V129.906Z"
        fill="#022E40"
      />
      <motion.path
        variants={svgPathVariants}
        d="M53.1113 136.709H0V142.916H53.1113V136.709Z"
        fill="#022E40"
      />
      <motion.path
        variants={svgPathVariants}
        d="M211 137.995H104.183V142.916H211V137.995Z"
        fill="#022E40"
      />
      <motion.path
        variants={svgPathVariants}
        d="M158.217 139.536H0V142.923H158.217V139.536Z"
        fill="#022E40"
      />
      <motion.path
        variants={svgPathVariants}
        d="M53.1113 146.179H0V152.387H53.1113V146.179Z"
        fill="#022E40"
      />
      <motion.path
        variants={svgPathVariants}
        d="M211 147.466H104.183V152.387H211V147.466Z"
        fill="#022E40"
      />
      <motion.path
        variants={svgPathVariants}
        d="M158.217 149.007H0V152.394H158.217V149.007Z"
        fill="#022E40"
      />
      <motion.path
        variants={svgPathVariants}
        d="M53.1113 155.497H0V161.705H53.1113V155.497Z"
        fill="#022E40"
      />
      <motion.path
        variants={svgPathVariants}
        d="M211 156.777H104.183V161.697H211V156.777Z"
        fill="#022E40"
      />
      <motion.path
        variants={svgPathVariants}
        d="M158.217 158.318H0V161.705H158.217V158.318Z"
        fill="#022E40"
      />
      <motion.path
        variants={svgPathVariants}
        d="M53.1113 164.648H0V170.855H53.1113V164.648Z"
        fill="#022E40"
      />
      <motion.path
        variants={svgPathVariants}
        d="M211 165.935H104.183V170.855H211V165.935Z"
        fill="#022E40"
      />
      <motion.path
        variants={svgPathVariants}
        d="M158.217 167.475H0V170.862H158.217V167.475Z"
        fill="#022E40"
      />
      <motion.path
        variants={svgPathVariants}
        d="M53.1113 174.438H0V180.646H53.1113V174.438Z"
        fill="#022E40"
      />
      <motion.path
        variants={svgPathVariants}
        d="M211 174.62H104.183V180.646H211V174.62Z"
        fill="#022E40"
      />
      <motion.path
        variants={svgPathVariants}
        d="M158.217 176.634H0V180.646H158.217V176.634Z"
        fill="#022E40"
      />
      <motion.path
        variants={svgPathVariants}
        d="M53.1113 183.909H0V190.116H53.1113V183.909Z"
        fill="#022E40"
      />
      <motion.path
        variants={svgPathVariants}
        d="M211 184.091H104.183V190.116H211V184.091Z"
        fill="#022E40"
      />
      <motion.path
        variants={svgPathVariants}
        d="M158.217 186.104H0V190.116H158.217V186.104Z"
        fill="#022E40"
      />
      <motion.path
        variants={svgPathVariants}
        d="M53.1113 193.699H0V199.907H53.1113V193.699Z"
        fill="#022E40"
      />
      <motion.path
        variants={svgPathVariants}
        d="M211 192.929H104.183V199.907H211V192.929Z"
        fill="#022E40"
      />
      <motion.path
        variants={svgPathVariants}
        d="M158.217 195.895H0V199.907H158.217V195.895Z"
        fill="#022E40"
      />
      <motion.path
        variants={svgPathVariants}
        d="M53.1113 202.85H0V209.057H53.1113V202.85Z"
        fill="#022E40"
      />
      <motion.path
        variants={svgPathVariants}
        d="M211 202.087H104.183V209.065H211V202.087Z"
        fill="#022E40"
      />
      <motion.path
        variants={svgPathVariants}
        d="M158.217 205.045H0V209.057H158.217V205.045Z"
        fill="#022E40"
      />
      <motion.path
        variants={svgPathVariants}
        d="M53.1113 212.168H0V218.375H53.1113V212.168Z"
        fill="#022E40"
      />
      <motion.path
        variants={svgPathVariants}
        d="M211 211.398H104.183V218.375H211V211.398Z"
        fill="#022E40"
      />
      <motion.path
        variants={svgPathVariants}
        d="M158.217 214.363H0V218.375H158.217V214.363Z"
        fill="#022E40"
      />
      <motion.path
        variants={svgPathVariants}
        d="M53.1113 221.799H0V228.006H53.1113V221.799Z"
        fill="#022E40"
      />
      <motion.path
        variants={svgPathVariants}
        d="M211 221.326H104.183V228.006H211V221.326Z"
        fill="#022E40"
      />
      <motion.path
        variants={svgPathVariants}
        d="M158.217 223.994H0V228.006H158.217V223.994Z"
        fill="#022E40"
      />
      <motion.path
        variants={svgPathVariants}
        d="M53.1113 231.269H0V237.476H53.1113V231.269Z"
        fill="#022E40"
      />
      <motion.path
        variants={svgPathVariants}
        d="M211 230.797H104.183V237.476H211V230.797Z"
        fill="#022E40"
      />
      <motion.path
        variants={svgPathVariants}
        d="M158.217 233.464H0V237.476H158.217V233.464Z"
        fill="#022E40"
      />
      <motion.path
        variants={svgPathVariants}
        d="M53.1113 241.372H0V247.579H53.1113V241.372Z"
        fill="#022E40"
      />
      <motion.path
        variants={svgPathVariants}
        d="M211 240.9H104.183V247.579H211V240.9Z"
        fill="#022E40"
      />
      <motion.path
        variants={svgPathVariants}
        d="M158.217 243.567H0V247.579H158.217V243.567Z"
        fill="#022E40"
      />
      <motion.path
        variants={svgPathVariants}
        d="M53.1113 250.843H0V257.05H53.1113V250.843Z"
        fill="#022E40"
      />
      <motion.path
        variants={svgPathVariants}
        d="M211 250.377H104.183V257.057H211V250.377Z"
        fill="#022E40"
      />
      <motion.path
        variants={svgPathVariants}
        d="M158.217 253.038H0V257.05H158.217V253.038Z"
        fill="#022E40"
      />
      <motion.path
        variants={svgPathVariants}
        d="M53.1113 260.786H0V266.993H53.1113V260.786Z"
        fill="#022E40"
      />
      <motion.path
        variants={svgPathVariants}
        d="M211 260.32H104.183V267H211V260.32Z"
        fill="#022E40"
      />
    </motion.g>
    <defs>
      <clipPath id="clip0_cfos">
        <rect width="211" height="267" fill="white" />
      </clipPath>
    </defs>
  </motion.svg>
);

